import ActorService from '@/common/api/actor'
import MessageService from '@/common/api/message'
import {
  POST_MESSAGE,
  POST_MESSAGE_BY_SETTING,
  GET_MESSAGES_LIST,
  GET_MESSAGE,
  GET_MESSAGE_IMAGE,
  GET_MESSAGE_VOICE,
  GET_THREADS
} from './actions'
import {
  FETCH_POST_MESSAGE,
  FETCH_MESSAGES_LIST,
  FETCH_MESSAGE,
  FETCH_THREADS
} from './mutations'

const state = {
  postMessage: {},
  messagesList: [],
  message: {},
  threads: []
}

const getters = {
  postMessage (state) {
    return state.postMessage
  },
  messagesList (state) {
    return state.messagesList
  },
  message (state) {
    return state.message
  }
}

const actions = {
  [POST_MESSAGE] (context, { id, params = {} }) {
    return new Promise((resolve, reject) => {
      ActorService.postMessage(id, params)
        .then(({ data }) => {
          context.commit(FETCH_POST_MESSAGE, data)
          resolve(data)
        })
        .catch(error => {
          context.commit(FETCH_POST_MESSAGE, null)
          reject(error)
        })
    })
  },
  [POST_MESSAGE_BY_SETTING] (context, { id, settingId, params = {} }) {
    return new Promise((resolve, reject) => {
      ActorService.postMessageBySetting(id, settingId, params)
        .then(({ data }) => {
          context.commit(FETCH_POST_MESSAGE, data)
          resolve(data)
        })
        .catch(error => {
          context.commit(FETCH_POST_MESSAGE, null)
          reject(error)
        })
    })
  },
  [GET_MESSAGES_LIST] (context, { params = {} }) {
    return new Promise((resolve, reject) => {
      MessageService.getList(params)
        .then(({ data }) => {
          context.commit(FETCH_MESSAGES_LIST, data)
          resolve(data)
        })
        .catch(error => {
          context.commit(FETCH_MESSAGES_LIST, null)
          reject(error)
        })
    })
  },
  [GET_MESSAGE] (context, { id, params = {} }) {
    return new Promise((resolve, reject) => {
      MessageService.get(id, params)
        .then(({ data }) => {
          context.commit(FETCH_MESSAGE, data)
          resolve(data)
        })
        .catch(error => {
          context.commit(FETCH_MESSAGE, null)
          reject(error)
        })
    })
  },
  [GET_MESSAGE_IMAGE] (context, { id, params = {} }) {
    return new Promise((resolve, reject) => {
      MessageService.getImage(id, params)
        .then(({ data }) => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  [GET_MESSAGE_VOICE] (context, { id, params = {} }) {
    return new Promise((resolve, reject) => {
      MessageService.getVoice(id, params)
        .then(({ data }) => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  [GET_THREADS] (context, { params = {} }) {
    return new Promise((resolve, reject) => {
      MessageService.getThreads(params)
        .then(({ data }) => {
          context.commit(FETCH_THREADS, data)
          resolve(data)
        })
        .catch(error => {
          context.commit(FETCH_THREADS, null)
          reject(error)
        })
    })
  }
}

const mutations = {
  [FETCH_POST_MESSAGE] (state, data) {
    state.postMessage = data
  },
  [FETCH_MESSAGES_LIST] (state, data) {
    state.messagesList = data
  },
  [FETCH_MESSAGE] (state, data) {
    state.message = data
  },
  [FETCH_THREADS] (state, data) {
    state.threads = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
